import { Box, Button, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

import { pillButtonSx } from "../styles/sectionStyles"

const EmptyState = ({ title, description, actions = [] }) => (
    <Box
        textAlign="center"
        py={6}
        px={3}
        borderRadius={3}
        sx={{
            background: "rgba(255,255,255,0.85)",
            border: "1px solid rgba(0, 4, 53, 0.08)",
        }}
    >
        <Typography variant="h6" fontWeight={800} color="#000435" gutterBottom>
            {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={actions.length ? 3 : 0}>
            {description}
        </Typography>

        {actions.length > 0 && (
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
                {actions.map((action) => (
                    <Button
                        key={action.label}
                        component={action.href ? Link : undefined}
                        to={action.href}
                        variant={action.variant || "contained"}
                        color={action.color || "secondary"}
                        size="large"
                        onClick={action.onClick}
                        sx={{
                            ...pillButtonSx,
                            px: 3,
                            ...(action.variant === "outlined" && {
                                borderColor: "rgba(0, 4, 53, 0.2)",
                                color: "#000435",
                            }),
                        }}
                    >
                        {action.label}
                    </Button>
                ))}
            </Stack>
        )}
    </Box>
)

export default EmptyState
